const state = {
  show: false
}

const getters = {
  showPrivacy: state => state.show
}

const actions = {
  showPrivacy ({ commit }) {
    commit('setShow', true)
  },
  hidePrivacy ({ commit }) {
    commit('setShow', false)
  }
}

const mutations = {
  setShow (state, show) {
    state.show = show
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
